
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import HeaderBanner from '../HeaderBanner/index.vue'
import Recommend from '../Recommend/index.vue'
import BrandStory from '../BrandStory/index.vue'
import SpecialZone from '../SpecialZone/index.vue'
import { ClickEvent } from '@xt/client/types/home.d'

@Component({
  components: {
    HeaderBanner,
    Recommend,
    BrandStory,
    SpecialZone
  }
})
export default class extends Vue {
  @Prop() dataSource: {
    banner: Array<{ cover: string; event?: ClickEvent }>
    recommend: Array<{ cover: string; event?: ClickEvent; name: string }>
    specialZone: {
      calligraphy: { event?: ClickEvent }
      prepareExhibition: { event?: ClickEvent }
      chinesePaint: { event?: ClickEvent }
      dayCourse: { event?: ClickEvent }
      coupon: { event?: ClickEvent }
    }
    brandStory: { event?: ClickEvent }
  }

  @Emit('show-qrcode-pop')
  handleShowQrcode(data) {
    return data
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
